import { render, staticRenderFns } from "./VatInput.vue?vue&type=template&id=d4780ee2&"
import script from "./VatInput.vue?vue&type=script&lang=js&"
export * from "./VatInput.vue?vue&type=script&lang=js&"
import style0 from "./VatInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports